  function formatUSD(cents) {
    const value = cents / 100;
    return value % 1 === 0 
      ? ('$'+value.toString())   // Nếu là số nguyên thì bỏ phần .00
      : new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(value);
  }
  const setSalePrice = function (el) {
    const featuredProduct = el.closest('.featured-product');
    const thisvariant = el.closest('variant-selects').querySelector('.quantity-breaks-container');
    const inputChecked = thisvariant.querySelector('input[type="radio"]:checked');
    let price = parseInt(inputChecked.getAttribute('data-price'));
    let comapre_price = parseInt(inputChecked.getAttribute('data-compare-at-price'));
    let salePrice = comapre_price - price;
    let percentSalePrice = Math.floor((salePrice / comapre_price) * 100);
    if (percentSalePrice > 0) {
      featuredProduct.querySelector('.price__badge-sale').style.display = 'inline-flex';
      featuredProduct.querySelector('.price__badge-sale .nowrap').textContent = 'SAVE ' + percentSalePrice + '%';
    } else {
      featuredProduct.querySelector('.price__badge-sale').style.display = 'none';
    }
    fixCheckoutBtn(el);
  };
  const fixCheckoutBtn = function (el){
    const thisvariant = el.closest('variant-selects').querySelector('.quantity-breaks-container');
    setTimeout(() => {
      const btnCheckout = thisvariant.closest('.product__info-container').querySelector('button.product-form__submit');
      if(btnCheckout.hasAttribute("disabled")){
        thisvariant.closest('.product__info-container').querySelector('button.product-form__submit').removeAttribute('disabled');
      }else{
        setTimeout(() => {
            thisvariant.closest('.product__info-container').querySelector('button.product-form__submit').removeAttribute('disabled');
        }, 800);
      }
    }, 800);
  }
  
  const variantPick = function (el) {
    let compare_price = 0;
    let price = 0;
    let priceforeach = 0;
    const productData = JSON.parse(
      el.closest('.section-related-product').querySelector('.product-json-custom').textContent
    );
    const thisvariant = el.closest('variant-selects').querySelector('.quantity-breaks-container');
    const variantinpack = [];
    const packNumber = parseInt((el.value.match(/\d+/) || [])[0], 10) || null;
    productData.forEach((v) => {
      if (el.value === v.option1) variantinpack.push(v);
    });
    variantinpack.forEach((v) => {
      compare_price = v.compare_at_price; 
      price = v.price;
      priceforeach = Math.floor(price / packNumber);
      thisvariant.querySelectorAll('input[type="radio"]').forEach((i) => {
        if (i.value === v.option2) {
          i.setAttribute('data-price', price);
          i.setAttribute('data-compare-at-price', compare_price);
          let labelUpdateData = i.nextElementSibling;
          labelUpdateData.getElementsByClassName('price-for-each')[0].innerHTML =
            '<span>' + formatUSD(priceforeach) + '</span><span> each</span>';
          labelUpdateData.getElementsByClassName('quantity-break__price')[0].innerHTML =
            'Total: <span>' + formatUSD(price) + '</span>';
          labelUpdateData.getElementsByClassName('quantity-break__compare-price')[0].innerHTML =
            '<span>' + formatUSD(compare_price) + '</span>';
        }
      });
    });
    setSalePrice(el);
  
  };